<script>
  import filterClasses, { cssPrefix } from '../helper-classes.js'

  export let centered = false
  export let id = null

  export let style = null
  export let helperClass = null
  let importedClasses = ''
  export { importedClasses as class }
  export let classPermissiveMode = false
  if (helperClass) {
    console.debug("[DS:deprecation] please replace 'helperClass' prop by 'class'")
    if (!importedClasses) {
      importedClasses = helperClass
    }
  }
  const classes = [`${cssPrefix}tabs`]
  if (importedClasses) classes.push(...filterClasses(importedClasses, classPermissiveMode))

  if (centered) classes.push('is-centered')
</script>

<nav class={classes.join(' ')} {style} {id}>
  <ul>
    <slot />
  </ul>
</nav>
